/**
 * Resolve a post-auth redirect target from a user-supplied `?redirect=` value.
 *
 * Only same-origin relative paths are accepted: the value must start with a
 * single "/" but not "//" (a protocol-relative URL pointing at another host).
 * Anything else falls back to `fallback`. This guards against open-redirect
 * abuse of the `redirect` query parameter.
 */
export function safeRedirectPath(raw, fallback = '/dashboard') {
  return raw && raw.startsWith('/') && !raw.startsWith('//') ? raw : fallback;
}
